import { InstallationPriceRange } from 'src/app/stores/tunnel/model/installation-price-range';
import { logError } from './sentry.helper';

/** Retourne la liste de libellés d'un JSON sérialisé, ou une liste vide s'il est absent ou invalide. */
const parseLabels = (json: string | undefined): string[] => {
  try {
    return JSON.parse(json ?? '[]') ?? [];
  } catch (error) {
    logError(error);
    return [];
  }
};

/** Retourne la fourchette de prix de pose, ou `undefined` si aucune n'est fournie. */
export const toInstallationPriceRange = (installationPrice: {
  priceMin?: number;
  priceMax?: number;
  included?: string;
  toValidate?: string;
  excluded?: string;
}): InstallationPriceRange | undefined => {
  if (!installationPrice?.priceMin || !installationPrice?.priceMax) {
    return undefined;
  }

  return {
    min: installationPrice.priceMin,
    max: installationPrice.priceMax,
    included: parseLabels(installationPrice.included),
    toValidate: parseLabels(installationPrice.toValidate),
    excluded: parseLabels(installationPrice.excluded),
  };
};
